module.exports = __webpack_public_path__ + "img/man_body.f0cafec5.png";